/**
 * Custom error class for payment-related user errors.
 * These errors represent expected payment failures like insufficient funds,
 * declined cards, expired cards, etc. and should not be reported to error
 * monitoring services as they are user issues, not system errors.
 */
export class PaymentError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PaymentError';
    
    // Maintains proper stack trace for where our error was thrown (only works on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PaymentError);
    }
  }
}